import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Field } from 'formik';

function ContactInformationSection({ values, errors, touched, handleChange }) {
  return (
    <div className="form-section">
      <h3 className="section-title">Contact Information
        <small className="text-500"> (optional)</small>
      </h3>
      <Field name="contactEmail">
        {({ field, meta }) => (
          <div className="field">
            <label htmlFor="contactEmail">Email</label>
            <InputText
              id="contactEmail"
              {...field}
              className={meta.touched && meta.error ? 'p-invalid' : ''}
              placeholder="business@example.com"
            />
            {meta.touched && meta.error && (
              <small className="p-error">{meta.error}</small>
            )}
          </div>
        )}
      </Field>

      <Field name="contactPhone">
        {({ field, meta }) => (
          <div className="field">
            <label htmlFor="contactPhone">Phone Number</label>
            <InputText
              id="contactPhone"
              {...field}
              type="tel"
              className={meta.touched && meta.error ? 'p-invalid' : ''}
              placeholder="+1 (999) 999-9999"
              onKeyPress={(e) => {
                const allowedChars = /[0-9+\s()]/;
                if (!allowedChars.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {meta.touched && meta.error && (
              <small className="p-error">{meta.error}</small>
            )}
          </div>
        )}
      </Field>
    </div>
  );
}

export default ContactInformationSection;